var map = {
	"./cashback.svg": 2614,
	"./client.svg": 6196,
	"./constructor.svg": 4003,
	"./coupons.svg": 3415,
	"./discount.svg": 6134,
	"./domain.svg": 3590,
	"./order-bump.svg": 3516,
	"./promotional-kit.svg": 5727,
	"./recover.svg": 3924,
	"./social-tests.svg": 4059,
	"./upsell.svg": 1567,
	"./webhook.svg": 5687
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4597;